export default __webpack_public_path__ + "488c49a69a05f6c5c46d7e5cdd2f2b09.webp";